import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '../../../material.module';
import { MatTableModule } from '@angular/material/table'
import { MatIconModule } from '@angular/material/icon';
import { HomeComponent } from './home.component';
import { AdsenseModule } from 'ng2-adsense';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    AdsenseModule.forRoot(),
    CommonModule,
    HomeRoutingModule,
    FlexLayoutModule,
    MaterialModule,
    MatTableModule,
    MatIconModule,
  ],
  declarations: [HomeComponent]
})
export class HomeModule { }
